export default __webpack_public_path__ + "static/media/arrow-right.51a3734b.svg";